const STORAGE_KEY = 'usfcr_admin_mfa_device_trusted_at';

export const REMEMBER_DEVICE_DURATION_DAYS = 30;

const REMEMBER_DEVICE_DURATION_MS =
  REMEMBER_DEVICE_DURATION_DAYS * 24 * 60 * 60 * 1000;

export function markDeviceTrusted() {
  try {
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
  } catch (e) {
    // localStorage unavailable (private mode / disabled) - trust simply won't persist
  }
}

export function clearDeviceTrust() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // no-op
  }
}

export function hasDeviceTrust() {
  try {
    return Boolean(localStorage.getItem(STORAGE_KEY));
  } catch (e) {
    return false;
  }
}

export function isDeviceTrustExpired() {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    if (!value) {
      return false;
    }

    const trustedAt = Number(value);
    if (!Number.isFinite(trustedAt)) {
      return true;
    }

    return Date.now() - trustedAt > REMEMBER_DEVICE_DURATION_MS;
  } catch (e) {
    return false;
  }
}
